<form class="form-container" [formGroup]="form">
    <h2 mat-dialog-title>{{ TITLE | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <mat-form-field appearance="outline" class="form-field-spacing">
        <mat-label>{{ SEND_TO_LABEL | translate}} </mat-label>
        <input matInput formControlName="sendTo">
        @if (f['sendTo'].errors) {
            <mat-error style="margin-top:10px">
                @if (f['sendTo'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                    translate}}</span>}
                @if (f['sendTo'].errors['pattern']) { <span>{{'MAX_LENGTH_30' |
                    translate}}</span>}
            </mat-error>
        }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="form-field-spacing">
        <mat-label>{{'MESSAGE' | translate}} </mat-label>
            <textarea 
        matInput 
        formControlName="message" 
        style="padding: 15px 8px 10px 8px; min-height: 40px; resize: vertical;"
        rows="4">
    </textarea>
        @if (f['message'].errors) {
            <mat-error style="margin-top:10px">
                @if (f['message'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                    translate}}</span>}
            </mat-error>
        }
    </mat-form-field>
</mat-dialog-content>
    <mat-dialog-actions align="end">
            <button mat-raised-button [disabled]="form.invalid" (click)="onSubmit()" [mat-dialog-close]="form.value" color="primary"
                    cdkFocusInitial>{{'SEND' | translate}} </button>
            <button mat-raised-button mat-dialog-close>{{'Cancel' | translate}}</button>
    </mat-dialog-actions>
</form>